import api from "shared/api";
import { InvoiceRaw, AccessLogUserRaw } from "./models";

const prefix = "api/invoices";

export const getInvoicesForCurrentUser = async (): Promise<InvoiceRaw[]> => {
  try {
    const res = await api().get<InvoiceRaw[]>(`${prefix}/current-user`);
    return res.data;
  } catch (e) {
    throw e;
  }
};

export const getAccessLogs = async (): Promise<AccessLogUserRaw[]> => {
  try {
    const res = await api().get<AccessLogUserRaw[]>(`${prefix}/access-logs`);
    return res.data;
  } catch (e) {
    throw e;
  }
};
